import { capitalizeString } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { KpiLarge } from '@strata/react-kpi';
import { MessagingBlock } from '@strata/react-messaging-block';
import PropTypes from 'prop-types';

const formatBucketLabel = (label) => capitalizeString(label.replaceAll('_', ' '));

const BreakdownColumn = ({ title, totalCount, items, formatLabel = (label) => label }) => (
    <div className="sds_details-page-overview__container" style={{ flex: '1 0' }}>
        <FormSectionWithRows
            sectionTitle={`${title} (${totalCount})`}
            rowOneContent={
                items.length > 0 ? (
                    <div className="flex__gap--large" style={{ flexDirection: 'column' }}>
                        {items.map(({ label, count }) => (
                            <KpiLarge key={label} label={formatLabel(label)} value={count} />
                        ))}
                    </div>
                ) : (
                    <MessagingBlock
                        size={MessagingBlock.Sizes.SMALL}
                        secondaryText="No data available."
                    />
                )
            }
        />
    </div>
);

BreakdownColumn.propTypes = {
    title: PropTypes.string.isRequired,
    totalCount: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            count: PropTypes.number.isRequired,
        }),
    ).isRequired,
    formatLabel: PropTypes.func,
};

export const OrtfInboundFileOverviewContent = ({ largeTotal = false, overview }) => (
    <div className="margin__top--large">
        <div className={largeTotal ? 'sds_ortf-inbound-history-total' : undefined}>
            <KpiLarge label="Total Inbound Scripts" value={overview.totalRxCount} />
        </div>
        <div className="sds_details-page-overview margin__top--large">
            <BreakdownColumn
                title="Outbound Files"
                totalCount={overview.outboundFiles.totalCount}
                items={overview.outboundFiles.items}
            />
            <BreakdownColumn
                title="Remaining Transfers"
                totalCount={overview.remainingTransfers.totalCount}
                items={overview.remainingTransfers.items}
                formatLabel={formatBucketLabel}
            />
            <BreakdownColumn
                title="Manual Transfers"
                totalCount={overview.manualTransfers.totalCount}
                items={overview.manualTransfers.items}
            />
        </div>
    </div>
);

const breakdownItemsPropType = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
    }),
).isRequired;

OrtfInboundFileOverviewContent.propTypes = {
    largeTotal: PropTypes.bool,
    overview: PropTypes.shape({
        totalRxCount: PropTypes.number.isRequired,
        outboundFiles: PropTypes.shape({
            totalCount: PropTypes.number.isRequired,
            items: breakdownItemsPropType,
        }).isRequired,
        remainingTransfers: PropTypes.shape({
            totalCount: PropTypes.number.isRequired,
            items: breakdownItemsPropType,
        }).isRequired,
        manualTransfers: PropTypes.shape({
            totalCount: PropTypes.number.isRequired,
            items: breakdownItemsPropType,
        }).isRequired,
    }).isRequired,
};
